// extracted by mini-css-extract-plugin
module.exports = {"footer":"pureflo_footer__1SkXB","waveBorder":"pureflo_waveBorder__3oUy2","footerBlocks":"pureflo_footerBlocks__1xzEO","logo":"pureflo_logo__CFlEj"};